export interface HasValue {
  value: number
}
export function byValueAsc(a: HasValue, b: HasValue) {
  return a.value - b.value
}
export function byValueDesc(a: HasValue, b: HasValue) {
  return b.value - a.value
}